import { memo } from 'react';

import { Box, Typography } from '@mui/material';

import type { ComparisonMapItem } from './ComparisonMap';

import { priorityGroupsNames } from '@/features/offlineSalesOptimizer/common';
import { Tooltip } from '@/shared/components/tooltip';

interface ComparisonMapTooltipProps {
  position: { x: number; y: number } | null;
  item: ComparisonMapItem | null;
}

const ComparisonMapTooltip = ({
  position,
  item,
}: ComparisonMapTooltipProps) => {
  if (!position || !item) {
    return null;
  }

  const { bucket, areaName, populationSize } = item;

  return (
    <Tooltip
      title={
        <>
          <Typography variant='body3'>{areaName}</Typography>
          {bucket ? (
            <Typography variant='body2' pt={0.5} fontWeight={600}>
              {priorityGroupsNames[bucket]}
            </Typography>
          ) : (
            <Typography variant='body2' pt={0.5} color='text.disabled'>
              No data
            </Typography>
          )}
          <Typography variant='body3' pt={0.25} color='text.secondary'>
            Pop.{' '}
            {new Intl.NumberFormat('en-US', {
              maximumFractionDigits: 0,
            }).format(populationSize)}
          </Typography>
        </>
      }
      open={true}
      placement='top'
      sx={{ pointerEvents: 'none' }}
      slotProps={{ popper: { disablePortal: true } }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: position.x,
          top: position.y,
          width: 0,
          height: 0,
        }}
      />
    </Tooltip>
  );
};

export default memo(ComparisonMapTooltip);
